module.exports = __webpack_public_path__ + "img/sfondo-tortellini-alle-erbe.81f1166a.png";